module.exports = __webpack_public_path__ + "static/media/stop.31b56817.svg";